import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { blockDevToolsAndConsole } from './utils/blockDevToolsAndConsole';
import disableDevtool from 'disable-devtool';
import { HelmetProvider } from 'react-helmet-async';

/** Disable DevTools */
// blockDevToolsAndConsole();
const APP_DEBUG = process.env.REACT_APP_DEBUG === 'true';
if (!APP_DEBUG) {
  disableDevtool();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <App />
  </HelmetProvider>
  // </React.StrictMode>
);
